




































import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import IconViewer from '@/components/icons/Viewer.vue';

enum InputTypeEnum {
    Text = 'text',
    Password = 'password',
}

@Component({
    components: {
        IconViewer,
    },
})
export default class InputPassword extends Vue {
    @Model('input') value!: string
    @Prop() data!: any
    @Prop() additionalData: any
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: () => '' }) readonly error!: string;

    isMounted = false;
    type = InputTypeEnum.Password;
    isHidden = true
    classes = {
        in: 'cd-label-active',
    }
    isLabelActive = false

    get isLoginPage() {
        return this.$route.name === 'login';
    }

    get valueModel() {
        return this.value
    }

    set valueModel(value: string) {
        this.$emit('input', value);
    }

    get isErrors() {
        return this.error.length > 0;
    }

    addClassIn() {
        this.isLabelActive = true;
    }

    removeClassIn() {
        this.isLabelActive = false;
    }

    toggleType() {
        this.type = this.type === InputTypeEnum.Password ? InputTypeEnum.Text : InputTypeEnum.Password;
        this.isHidden = !this.isHidden;
    }

    mounted() {
        this.isMounted = true;
    }
}
